<template>
    <div class="md-house-listing fashion" v-if="exist">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="mg-title">
                <div class="main-title">
                    <div v-html="formatFontSize(titleContent, '--mg-title-size')" style="font-family:var(--mg-title-font);"></div>
                </div>
                <h3
                    class="sub-title"
                    v-if="baseUrl"
                    v-html="
                        $t('md-house-listing.basedOnListing', {
                            href: baseUrl,
                            address: baseListingAddr
                        })
                    "
                ></h3>
                <h3
                    class="sub-title"
                    v-if="!forMoreData && dataType === 'recommend'"
                >
                    {{ subTitle }}
                </h3>
            </div>
            <HouseList />
        </module-box>
    </div>
</template>

<script>
import Common from '../index.js';
import { getAsyComponent } from '@/common/utils/load-module.js';
export default {
    components: {
        HouseList: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/list-v3_list"*/ '../../md-house/list-v3/list.vue'
            ))
    },
    mixins: [Common]
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-house-listing.fashion {
    > div {
        overflow: visible;
    }
    .unlike {
        cursor: pointer;
        font-size: 14px;
        font-family: var(--font-normal);
        padding: 0 10px;
        background-color: #bcbcca;
        color: white;
        letter-spacing: 0.6px;
        line-height: 1.5;
    }
    .mg-title {
        position: relative;
        text-align: var(--mg-title-align);
        padding: 5px, 0;
        .main-title {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            h2{
                font-size: inherit;
            }
        }
        .pc-unlike {
            @extend .unlike;
            position: absolute;
            right: 0px;
            top: calc(50% - 10px);
            transform: translateY(-50%);
        }
       
    }
    .sub-title {
        font-size: 14px;
        margin-top: 5px;
        color: #8b93a7;
        font-family: var(--font-medium);
        letter-spacing: normal;
        white-space: pre-line;
        a {
            color: #03c9ff;
        }
    }
    .mobile-unlike-container {
        display: none;
        justify-content: center;
        .mobile-unlike {
            @extend .unlike;
            margin: 20px auto 0 auto;
            display: inline-block;
        }
    }

    @include media-600 {
        .mg-title {
            .unlike {
                display: none;
            }
        }
        .sub-title {
            font-size: 12px;
        }
        .mobile-unlike-container {
            display: flex;
        }
    }
}
</style>
